import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface EyebrowProps {
    children: ReactNode
    className?: string
}

export const Eyebrow: FC<EyebrowProps> = ({ children, className }): ReactNode => {
    return (
        <p className={cn('inline-flex items-center gap-3 font-mono text-[0.72rem] uppercase tracking-[0.22em] text-electric-soft', className)}>
            <span aria-hidden='true' className='h-px w-8 bg-linear-to-r from-electric to-electric-soft' />
            {children}
        </p>
    )
}
